// extracted by mini-css-extract-plugin
export default {"Title":"NewsBanner_Title__BEgOD"};